import React, { useEffect, useState } from "react";
import "../../Styles/EmployeePayroll.css";
import { useSelector } from "react-redux";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { employeeList, employeePayRoleApi, employeepayrollBulk, getEmployeePayroleList, getExpendituresApi, getMonthWiseLeave } from "../../Services/Operations/ProductAPI";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const EmployeePayroll = () => {
  const token = useSelector((state) => state.user.token);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [formData, setFormData] = useState({ casualLeave: 0, unpaidLeave: 0 });
  const[tableMode,setTableMode]=useState(true)
  const[expenditures,setExpenditures]=useState([])
  const[allPayrollList,setAllPayrollList]=useState([])
  const[currentMonthPaid,setCurrentmonthPaid]=useState(false)
  const[userLeaveList,setUserLeaveList]=useState([])


  const navigate = useNavigate();
  const location = useLocation();
  const { EmployeeSelectId } = location.state || {};

  const [daysInMonth, setDaysInMonth] = useState(30);

  const today = new Date();
const currentMonth = today.getMonth();     // 0–11
const currentYear = today.getFullYear();

const isCurrentMonth = (dateStr) => {
  const [year, month] = dateStr.split("-").map(Number);
  return year === currentYear && month === currentMonth+1;
};


   const fetchExpendituresList = async () => {
        try {
          const response = await getExpendituresApi(token);
          
          const filteredData = response.filter(item => {
               const date = new Date(item.expenditureDate);
                 return (
                   date.getMonth() === currentMonth &&
                    date.getFullYear() === currentYear
                      );
                  });
                console.log('filteredData',filteredData);
                  
          setExpenditures(filteredData || []);
        } catch (error) {
          console.error("Error fetching expenditures:", error);
        }
      };

       const handleGetPauroleList=async()=>{
          try {
            const response=await getEmployeePayroleList(token)
            console.log("payrole list : ",response);
            if(response.data.status==='success'){
              setAllPayrollList(response.data.data)
            }
            if(isCurrentMonth(response.data.data[0].recordMonth)){
              console.log("true, yes it s current mnth paid");
              setCurrentmonthPaid(true)
            }
            
          } catch (error) {
            console.log("error : ",error);
            
          }
        }

      const  handleGetMonthWiseLeave=async()=>{
        try {
          const response=await getMonthWiseLeave(token)
          console.log("getMonthWiseLeave",response);
          if(response.status===200){
            let leaveList=response.data
            leaveList.map(item=>{
              item.unpaid=item.leaves.reduce((sum, leave) => {
  return leave.leaveType === 5 ? sum + leave.totalDays : sum;
}, 0);

       item.otehrLeave=item.leaves.reduce((sum, leave) => {
  return leave.leaveType !== 5? sum + leave.totalDays : sum;
}, 0);
            })
     

console.log("user leave list",leaveList);

  setUserLeaveList(leaveList)
            


          }
          
        } catch (error) {
          console.log(error);
          
        }
      }

      useEffect(() => {
       fetchExpendituresList()
       handleGetPauroleList()
       handleGetMonthWiseLeave()
      }, [])
      
  

useEffect(() => {

  const fnc=()=>{
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  setDaysInMonth(new Date(year, month, 0).getDate());}
  fnc()
}, []);

  useEffect(() => {
    const fetchEmployeeList = async () => {
      try {
        const response = await employeeList(token);
        console.log("Employee list",response);
        const updated = response.map(obj => ({
  ...obj,
  unpaidLeave: (userLeaveList.find(l=>l.employeeId===obj.id))?.unpaid||0,
  casualLeave:  (userLeaveList.find(l=>l.employeeId===obj.id))?.otehrLeave||0,
  ctc : obj?.ctc || 0,
  grossSalary : obj?.grossSalary || 0,
  payableSalary : Number((obj?.grossSalary - (0* (Number(obj?.grossSalary)/daysInMonth))).toFixed(2)),
  daExpenditure:(expenditures.filter(item => item.employeeId === obj.id).reduce((total, item) => total + Number(item.expenditureAmount || 0), 0) )
        
}));


        
        setEmployees(updated);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };
    fetchEmployeeList();
    handleGetPayroleList()
  
  }, [expenditures,userLeaveList]);

  const handleSelectEmployee = (employee) => {
    setSelectedEmployee(employee);
    setFormData({ casualLeave: 0, unpaidLeave: 0 });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: parseInt(value || 0) }));
  };
const handleSubmit = async (e) => {
  e.preventDefault();

  console.log({
    formData,
    selectedEmployeeId: selectedEmployee?.id,
    ctc,
    grossSalary,
    payableSalary,
  });

  if (!selectedEmployee?.id) {
    toast.error("Please select an employee");
    return;
  }

  try {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); 
    const year = today.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    const payload = {
      ...formData,          
      ctc,                 
      grossSalary,       
      paymentAmount: payableSalary,     
      recordMonth: formattedDate, 
      employeeId: selectedEmployee.id, 
    };

    console.log("Final Payload:", payload); 

    const response = await employeePayRoleApi(
      payload,          
      selectedEmployee.id, 
      token          
    );

    if (response.status === 200) {
      toast.success("Payroll saved successfully!");
      setFormData({ casualLeave: 0, unpaidLeave: 0 });
      setSelectedEmployee(null);
      navigate("/employee");
    } else {
      toast.error(response.data?.message || "Failed to save payroll");
    }
  } catch (error) {
    console.error("Payroll submission error:", error);
    toast.error(error.response?.data?.message || "Server error");
  }
};

  const ctc = selectedEmployee?.ctc || 0;
  const grossSalary = selectedEmployee?.grossSalary || 0;
  const { unpaidLeave } = formData;
  const payableSalary = (grossSalary - (unpaidLeave* grossSalary/daysInMonth)).toFixed(2)
 

  const handleGetPayroleList=async()=>{
      try {
        const response=await getEmployeePayroleList(token)
        console.log("payrole records list : ",response);
        
      } catch (error) {
        console.log("error : ",error);
        
      }
    }

    const handlePayment=async()=>{
      try {
        
         const today = new Date(Date.now());
const formatted = today.toISOString().split("T")[0];
  let data= employees.map((item,ind )=> ({
    employeeId:item.id,
    // casualLeave: item.casualLeave,
    // unpaidLeave:item.unpaidLeave,
    ctc:item.ctc,
    paymentAmount:Number((item?.grossSalary - (item.unpaidLeave* item?.grossSalary/daysInMonth)).toFixed(2)),
    grossSalary: item.grossSalary,
    recordMonth:formatted,
    totalDaForMonth:item.daExpenditure,
   finalPaymentAmount:Number(((item?.grossSalary - (item.unpaidLeave* item?.grossSalary/daysInMonth))+item.daExpenditure).toFixed(2))
  }));
  console.log(data);

  const response=await employeepayrollBulk({data,token});
  console.log("employeepayrollBulk",response);
  if(response.status===200){
    toast.success("Payment Successfull")
  }else{
    toast.error("failed to make payment")
  }
  
  

        
      } catch (error) {
        console.log(error);
        if(error.status===409){
          toast.info("Payment Already complete for this month")
          return
        }
          toast.error("failed to make payment")
      }
    }

    const transformData = (data) => {
  return data.map((item,ind )=> ({
    SlNo:ind+1,
    EmployeeName: item.firstName+item.lastName,
    UjjivanSalaryAccountNumber:item.bankAccountNumber,

    SalaryAmount: (item?.grossSalary - (item.unpaidLeave* item?.grossSalary/daysInMonth)).toFixed(2)+item.daExpenditure,
    Narration:"Salary for month"
  }));
};

const generateSalaryExcel = async () => {
  const transformed = transformData(employees);

  // 1. Load template from public folder
  const response = await fetch("/assets/salary-template.xlsx");
  const arrayBuffer = await response.arrayBuffer();

  // 2. Read workbook from buffer
  const workbook = XLSX.read(arrayBuffer, { type: "array" });

  // 3. Use first sheet
  const sheetName = workbook.SheetNames[0];
  const sheet = workbook.Sheets[sheetName];

  // 4. Start writing at row 7
  const startRow = 7;

  transformed.forEach((row, index) => {
    const excelRow = startRow + index;

    sheet[`A${excelRow}`] = { v: row.SlNo };
    sheet[`B${excelRow}`] = { v: row.EmployeeName };
    sheet[`C${excelRow}`] = { v: row.UjjivanSalaryAccountNumber };
    sheet[`D${excelRow}`] = { v: row.SalaryAmount };
    sheet[`E${excelRow}`] = { v: row.Narration };
  });

  // Fix sheet range
  const range = XLSX.utils.decode_range(sheet["!ref"]);
  range.e.r = startRow + transformed.length;
  sheet["!ref"] = XLSX.utils.encode_range(range);

  // 5. Download final file
  XLSX.writeFile(workbook, "Generated_Salary_File.xlsx");
};

  return (
    <div id="main_content">
      <Header />
      <div className="page payroll-wrapper">
        <Section />
        <div className="payroll-container">
          {/* <div className="employee-sidebar" style={{height:"95vh",maxHeight:"95vh",overflowY:"auto"}}>
            <h3>Employees</h3>
            {employees.map((emp) => (
              <div
                key={emp.id}
                className={`employee-card ${selectedEmployee?.id === emp.id ? "active" : ""}`}
                onClick={() => {handleSelectEmployee(emp);setTableMode(false)}}
              >
                {emp.firstName} {emp.lastName}
              </div>
            ))}
          </div> */}

          <div className="form-section">
         
              <div className="form-placeholder">
                 <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr style={{fontSize:'14px'}}>
          <th>ID</th>
          <th>Name</th>
          
          <th>Age</th>
          <th>Unpaid Leaves</th>
          <th>Casual Leave</th>
          <th>Bank Account Number</th>
          <th>CTC</th>
          <th>Gross Salary</th>
          
          <th>Payable salary</th>
          <th>DAExpenditure</th>
          <th>Salary After Expendeture</th>
          <th>Assigned Roles</th>
        </tr>
      </thead>

      <tbody style={{color:"black"}}>
        {employees.map((item,ind) => (
          <tr key={item.id}
          style={{fontSize:"14px"}}>
            <td>{ind+1}</td>
            <td> {item.firstName} {item.lastName}</td>
            <td>{item.age}</td>
            <td><input placeholder="Unpaid leaves" type="number" value={item.unpaidLeave}
            onChange={(e) => {
        const value = Number(e.target.value);
        if(value>daysInMonth){return}

       setEmployees((prev) =>
        prev.map((emp, i) =>
        i === ind ? { ...emp, unpaidLeave: value,payableSalary:(emp?.grossSalary - (value* emp?.grossSalary/daysInMonth)).toFixed(2) } : emp
        )
      );
     }}/>
            </td>
              <td><input placeholder="casual leaves" type="number" value={item.casualLeave}
            onChange={(e) => {
        const value = Number(e.target.value);

       setEmployees((prev) =>
        prev.map((emp, i) =>
        i === ind ? { ...emp, casualLeave: value } : emp
        )
      );
     }}/>
            </td>
            <td>{item.bankAccountNumber}</td>
            <td>{item.ctc}</td>
            <td>{item.grossSalary}</td>
            <td>{ item.payableSalary}</td>
            <td>{item.daExpenditure}</td>
            <td>{item.payableSalary+item.daExpenditure}</td>
            <td>{item.roles?.map(i=>i.employeeRoleName)}</td>
          </tr>
        ))}
      </tbody>
    </table>
              </div>
           
          </div>

        {tableMode&&<div style={{display:"flex",gap:"25px",position:"absolute",top:"80px",zIndex:999,right:"60px"}}>  
          <div onClick={()=>handlePayment()}
          style={{padding:"8px",borderRadius:"5px",backgroundColor:"#1a97fdff",color:"white",fontWeight:"600",cursor:currentMonthPaid?"not-allowed":"pointer"}}>
         { currentMonthPaid? "Paid" :"Make Payment"}
          </div>
          <div onClick={generateSalaryExcel}
          style={{padding:"8px",borderRadius:"5px",backgroundColor:"#1a97fdff",color:"white",fontWeight:"600",cursor:"pointer"}}>
            Download Excel
          </div>
          </div>
          }
        </div>
      </div>
    </div>
  );
};

export default EmployeePayroll;
